import { Injectable } from '@angular/core';
import { PdfInstanceManagerService } from './instance/pdf-instance-manager.service';
import { TabService } from './tab.service';
import { DediconPDFService } from './dedicon-pdf.service';
import { MimeTypesEnum } from '../utils/enums';
import { DocumentManagerService } from './document/document-manager.service';
import { AsgardDocPdf } from '../core/documents/asgard-doc-pdf';
import { environment } from 'src/environments/environment';
import { getExtensionFromMimeTypeString } from './cloud-storage/common';
import { Core,  } from '@pdftron/webviewer';


@Injectable({
  providedIn: 'root'
})
export class BlobToPdfService {

  // private get internalWV(): HTMLIFrameElement | null {
  //   const wvElement = document.getElementById('webviewerInternal');
  //   return wvElement !== null ? wvElement.querySelector('iframe') as HTMLIFrameElement : null;
  // }

  // private get internalPDFNet(): any | null {
  //   return this.internalWV !== null ? (this.internalWV.contentWindow as any).PDFNet : null;
  // }

  private get PDFNet(): typeof Core.PDFNet {
    return (window as any).Core.PDFNet;
  }

  constructor(
    private pdfService: PdfInstanceManagerService,
    private tabService: TabService,
    private dediconPDFService: DediconPDFService,
    private readonly docMgrService: DocumentManagerService
  ) {
  }

  async getCurrentPDF(): Promise<File | null> {
    const data = await this.getFileData()
    .catch(error => {
      console.error(`error getting current pdf: ${error}`);
      return null;
    });

    if (this.tabService.activeTab && data) {
      const arr = new Uint8Array(data);
      const blob = new Blob([arr], { type: 'application/pdf' });
      return new File(
        [blob], this.tabService.activeTab.title,
        { type: 'application/pdf' }
      );
    }
    return null;
  }

  convertArrayToFile(buffer, filename): File {
    const arr = new Uint8Array(buffer);
    const blob = new Blob([arr], { type: MimeTypesEnum.ApplicationPdf });
    return new File(
      [blob], filename,
      { type: MimeTypesEnum.ApplicationPdf }
    );
  }

  async convertFileToPdfDoc(file): Promise<Core.PDFNet.PDFDoc | null> {
    const data = await ((file as any).arrayBuffer() as Promise<ArrayBuffer>);
    const arr = new Uint8Array(data);
    if (this.PDFNet.PDFDoc && this.PDFNet.PDFDoc.createFromBuffer) {
      return await this.PDFNet.PDFDoc.createFromBuffer(arr);
    }
    return null;
  }

  async convertOfficeToPDF(officeFile: File): Promise<File> {
    const extension = getExtensionFromMimeTypeString(officeFile.type);

    let fileName = officeFile.name;
    if (fileName.includes(extension)) {
      fileName = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
      fileName = `${fileName}.pdf`;
    }

    const officeBuf = await officeFile.arrayBuffer();
    // NOTE (21 aug 2024)
    // suggested fix from: https://community.apryse.com/t/angular-11-core-not-defined-when-implementing-custom-ui/5989/5
    const pdfBuf = await ((window as any).Core as any).officeToPDFBuffer(officeBuf, { extension, l: environment.pdfTronLicenceKey });

    return this.convertArrayToFile(pdfBuf, fileName);
  }

  public async GetPdfFromTabId(tabID: string): Promise<File> {
    return this.getFileData(tabID)
    .then((data) => {
      return this.convertArrayToFile(data, this.tabService.getTabById(tabID)?.title);
    });
  }

  public async GetPdfFromTab(tabID: string, fileName: string): Promise<File> {
    return this.getFileData(tabID)
    .then((data) => {
      return this.convertArrayToFile(data, fileName);
    });
  }

  replaceExtension(fileName: string, newExt: string): string {
    const name = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
    return `${name}.${newExt}`;
  }

  private async getFileData(forID: string | null = null): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const currentDoc = this.docMgrService.currentDoc;
      if (currentDoc && currentDoc instanceof AsgardDocPdf) {
        currentDoc.clearTextHighlight();
      }

      let tabID = '';
      if (forID !== null) {
        tabID = forID;
      } else if (this.tabService.activeTab) {
        tabID = this.tabService.activeTab.id;
      } else {
        resolve(null);
      }

      const currentInstance = this.pdfService.getDocViewer(tabID);
      if (currentInstance) {
        const document = currentInstance.getDocument();

        await this.dediconPDFService.trySetDediconSecurityOnDocument(document);

        const annotationOptions: any = { links: false, widgets: false };
        const xfdfString = await currentInstance.getAnnotationManager().exportAnnotations(annotationOptions);

        resolve(document.getFileData({ xfdfString }));
      } else {
        console.error('getFileData() - could not retrieve data, no current instance !!')
        reject('no current instance');
      }
    });
  }
}
